module.exports = __webpack_public_path__ + "img/loyalty-program.e236b61c.png";